import React, { memo } from 'react';

import { hashHistory } from 'react-router';
import { MenuSectionNavType } from 'types/menu';

import * as Api from '../../../../../weborder/Api';
import { GroupHeader, TabsNav } from '../../../../molecules';
import { ItemVariant } from '../../../../molecules/TabsNav/TabsNav';

type RouteParams = {
  concessionStoreId?: number;
  id?: number;
  type?: 'collection' | 'delivery';
  vrid: number;
};

interface Props {
  activeConcessionStoreId: number;
  concessionStoreList: Api.ConcessionStore[];
  params?: RouteParams;
  translate: any;
}

function ConcessionNavComponent(props: Props): JSX.Element {
  const {
    activeConcessionStoreId,
    concessionStoreList,
    params,
    translate,
  } = props;
  const { vrid: vrId, type, id } = params;

  const handleConcessionNavClick = (concessionStoreId: number): void => {
    if (concessionStoreId !== activeConcessionStoreId) {
      hashHistory.push(
        `/restaurant/${vrId}/${type}/${id}/${concessionStoreId}`,
      );
    }
  };

  const getConcessionNavConfig = (store): MenuSectionNavType => ({
    disabled: store?.isDisabled,
    id: store.ConcessionStoreId,
    label: (
      <GroupHeader
        isActive={store.ConcessionStoreId === Number(activeConcessionStoreId)}
        src={store.ImageUrl}
        title={store.Name}
        variant="tile"
        warningMsg={
          store.isDisabled &&
          translate('StoreMenu_ConcessionNav_StoreClosedWarning')
        }
      />
    ),
    labelText: store.Name,
    src: store.ImageUrl,
  });

  const concessionStoreTabs = concessionStoreList.map((store) =>
    getConcessionNavConfig(store),
  );

  return (
    <TabsNav
      idPrefix="concession"
      itemVariant={ItemVariant.Blank}
      onTabClick={handleConcessionNavClick}
      TabIndicatorProps={{ style: { display: 'none' } }}
      tabs={concessionStoreTabs}
      value={activeConcessionStoreId}
    />
  );
}

const ConcessionNav = memo(ConcessionNavComponent);
ConcessionNav.displayName = 'ConcessionNav';

export { ConcessionNav };
